import React from 'react'
import { Sort, Order } from '@/lib/api/round'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { IcomoonIcon } from '../../../atoms/IcomoonIcon'

export const ToggleSortButton: React.FC<{
  sortType: Sort
  sort: Sort
  order: Order
  toggleSort: (selectedSort: Sort) => void
}> = (props) => {
  return (
    <span
      css={css`
        margin-left: 3px;
        font-size: 10px;
        padding: 5px 7px;
        :hover {
          background-color: ${colors.gray50};
          border-radius: 50%;
          cursor: pointer;
        }
      `}
      onClick={() => {
        props.toggleSort(props.sortType)
      }}
    >
      {props.sort === props.sortType ? (
        props.order === 'desc' ? (
          <IcomoonIcon
            name="arrow8-down"
            css={css`
              color: ${colors.cyan50};
            `}
          />
        ) : (
          <IcomoonIcon
            name="arrow8-up"
            css={css`
              color: ${colors.cyan50};
            `}
          />
        )
      ) : (
        <IcomoonIcon name="sort-fill" />
      )}
    </span>
  )
}
